import {cx} from '@emotion/css';
import React, {ReactElement} from 'react';

import Field from '@fo/designSystem/Fields/Field/Field';
import {Field as FieldType} from '@fo/designSystem/Fields/types';
import {IconProps} from '@fo/root/designSystem/atoms/Icons/IconWrapper';
import {ETheme} from '@fo/root/Templates/TideTemplates/shared/enums/themes';

import styles from './RadioIconField.styles';

export interface ButtonInfo {
  image?: ReactElement<IconProps>;
  text: string;
  value: string;
  key?: string;
}

interface Props extends Omit<FieldType, 'onChange' | 'onBlur'> {
  onChange: (event: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void;
  options: ButtonInfo[];
  optionClassname?: string;
  theme?: ETheme;
}

function RadioIconField({
  errorMessage = '',
  label,
  name,
  onChange,
  onBlur,
  value,
  options,
  isDisabled,
  optionClassname,
  className,
  testId,
  theme,
}: Props): ReactElement {
  return (
    <Field label={label} name={name} errorMessage={errorMessage} isDisabled={isDisabled} className={className}>
      <div className={cx(styles.radioIconField)} data-testid={testId} data-disabled={isDisabled}>
        {options.map(({text, image, value: buttonValue, key}) => (
          <button
            name={name}
            id={`radioIconField__button--${buttonValue}`}
            data-testid={`radioIconField__button--${buttonValue}`}
            key={key || text}
            type="button"
            onClick={() => {
              onChange(buttonValue);
            }}
            onBlur={onBlur}
            className={cx(styles.button(value === buttonValue, isDisabled, theme), optionClassname)}
            aria-pressed={value === buttonValue}
            value={buttonValue}
            disabled={isDisabled}
          >
            {image && React.cloneElement(image, {className: cx(styles.image)})}
            {text}
          </button>
        ))}
      </div>
    </Field>
  );
}

export default RadioIconField;
